import { render, staticRenderFns } from "./ComponentTopBarIcon.vue?vue&type=template&id=53a21e73&"
import script from "./ComponentTopBarIcon.vue?vue&type=script&lang=js&"
export * from "./ComponentTopBarIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports